module.exports = __webpack_public_path__ + "files/4467b7b71324602655a23ae431d607ed.png";